var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAboveTheFold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 96,
    viewBox: "0 0 140 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7082_300448)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.5376 12H3.23699C1.44925 12 0 13.4652 0 15.2727V80.7273C0 82.5348 1.44925 84 3.23699 84H99.5376C101.325 84 102.775 82.5348 102.775 80.7273V15.2727C102.775 13.4652 101.325 12 99.5376 12Z",
    fill: "#4F4C57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "black-triangle",
    d: "M45.7281 55.9203C46.1349 55.9203 46.4806 55.7656 46.8874 55.5433L58.7446 49.0288C59.5886 48.5552 59.8835 48.2459 59.8835 47.7336C59.8835 47.2214 59.5886 46.912 58.7446 46.4481L46.8874 39.9239C46.4806 39.7016 46.1349 39.5566 45.7281 39.5566C44.9756 39.5566 44.5078 40.0979 44.5078 40.9388V54.5285C44.5078 55.3693 44.9756 55.9203 45.7281 55.9203Z",
    fill: "#312F38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.724 15.2727C115.724 13.4652 114.275 12 112.487 12C110.699 12 109.25 13.4652 109.25 15.2727C109.25 17.0802 110.699 18.5455 112.487 18.5455C114.275 18.5455 115.724 17.0802 115.724 15.2727Z",
    fill: "#4F4C57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.661 15.2727C127.661 13.4652 126.212 12 124.424 12C122.637 12 121.188 13.4652 121.188 15.2727C121.188 17.0802 122.637 18.5455 124.424 18.5455C126.212 18.5455 127.661 17.0802 127.661 15.2727Z",
    fill: "#4F4C57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.595 15.2727C139.595 13.4652 138.146 12 136.358 12C134.57 12 133.121 13.4652 133.121 15.2727C133.121 17.0802 134.57 18.5455 136.358 18.5455C138.146 18.5455 139.595 17.0802 139.595 15.2727Z",
    fill: "#4F4C57"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7082_300448",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 21,
    width: 31,
    height: 63
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.364 21.8184H112.491C110.703 21.8184 109.254 23.2836 109.254 25.0911V80.7275C109.254 82.5349 110.703 84.0002 112.491 84.0002H136.364C138.151 84.0002 139.601 82.5349 139.601 80.7275V25.0911C139.601 23.2836 138.151 21.8184 136.364 21.8184Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7082_300448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.364 21.8184H112.491C110.703 21.8184 109.254 23.2836 109.254 25.0911C109.254 26.8986 110.703 28.3638 112.491 28.3638H136.364C138.151 28.3638 139.601 26.8986 139.601 25.0911C139.601 23.2836 138.151 21.8184 136.364 21.8184Z",
    fill: "#4F4C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.676 31.6367H112.491C110.703 31.6367 109.254 33.102 109.254 34.9094C109.254 36.7169 110.703 38.1822 112.491 38.1822H128.676C130.464 38.1822 131.913 36.7169 131.913 34.9094C131.913 33.102 130.464 31.6367 128.676 31.6367Z",
    fill: "#4F4C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.364 41.4551H112.491C110.703 41.4551 109.254 42.9203 109.254 44.7278C109.254 46.5353 110.703 48.0005 112.491 48.0005H136.364C138.151 48.0005 139.601 46.5353 139.601 44.7278C139.601 42.9203 138.151 41.4551 136.364 41.4551Z",
    fill: "#4F4C57"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7082_300448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 72,
    fill: "white",
    transform: "translate(0 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAboveTheFold);
export default __webpack_public_path__ + "static/media/icon-above-the-fold.c50abca686b06f565630590bac329850.svg";
export { ForwardRef as ReactComponent };